import { yupResolver } from '@hookform/resolvers/yup';
import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import _ from '@lodash';
import { startLoading, stopLoading } from 'app/store/utilSlice';
import { selectCurrentFolder, addFileItem } from 'app/store/fileItemsSlice';
import { useSelector, useDispatch } from 'react-redux';
import { dispatchResultMessage } from '../utils';
import ControlledTextField from '../form/ControlledTextField';
import DefaultButton from '../layout/DefaultButton';

/**
 * Form Validation Schema
 * 
 */
const schema = yup.object().shape({
  name: yup.string().required('You must enter a file name'),
  description: yup.string(),
});

  
function NewFolderDialog(props) {
  const { open, onCloseDialog } = props;
  const dispatch = useDispatch(); 
  const folderId= useSelector(selectCurrentFolder); 
  
  const defaultValues = {
	  name: '',
	  description: '',
  };
  
  const { handleSubmit, formState, control, reset } = useForm({
    mode: 'onChange',
    defaultValues: defaultValues,
    resolver: yupResolver(schema),
  });

  const { isValid, dirtyFields, errors } = formState;

  function handleCloseDialog() {
    onCloseDialog();
  }

  function handleDiscard() {
    onCloseDialog();
  }

  
  function onSubmit(data){
	  
	  //set the loading flag and close the dialog
	  dispatch(startLoading());
      onCloseDialog();
      
      dispatch(addFileItem({folderId: folderId,
		                    type: 'folder',
		                    name: data.name, 
		                    description: data.description})).then((resp) => {
		dispatchResultMessage(dispatch, resp, "Folder Created")
     });
	  
  }


  return (
      
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        aria-labelledby="form-dialog-title"
        scroll="body"
      >
        <AppBar position="static" color="secondary" elevation={0}>
          <Toolbar className="flex w-full">
            <Typography variant="subtitle1" color="inherit">
              Create New Folder
            </Typography>
          </Toolbar>
        </AppBar>

        <form noValidate onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
          <DialogContent classes={{ root: 'p-16 pb-0 sm:p-32 sm:pb-0' }}>
            <ControlledTextField name="name" label="Folder name"
                             control={control} errors={errors}
             				 autoFocus required fullWidth />
        
           <ControlledTextField name="description" label="Folder description"
                             control={control} errors={errors}
             				 required fullWidth />
            
          </DialogContent>

          <DialogActions className="flex flex-col sm:flex-row sm:items-center justify-between py-16 sm:py-24 px-24">

            <div className="flex items-center space-x-8 mt-16 sm:mt-0">
              <DefaultButton text="Cancel" onClick={handleDiscard} />
              <DefaultButton text="Create"
	              disabled={_.isEmpty(dirtyFields) || !isValid}
	              submit />
            </div>
          </DialogActions>
        </form>
      </Dialog>
  );
}

export default NewFolderDialog;
